import React, { Suspense } from "react";
import styled from "@emotion/styled";
import { ModuleLayoutMockTabs } from "src/framework/layout/ModuleLayoutMockTabs.tsx";

import { ModuleLayoutTabsV2 } from "src/framework/layoutV2/ModuleLayoutTabsV2.tsx";
import { ResolveAuthState } from "src/auth/components/ResolveAuthState/ResolveAuthState.tsx";

export type ModuleLayoutV2Props = {
  resource: string;
};

export function ModuleLayoutV2({ resource }: ModuleLayoutV2Props) {
  return (
    <LayoutContainer>
      <Suspense fallback={<ModuleLayoutMockTabs />}>
        <ResolveAuthState
          LoggedIn={ModuleLayoutTabsV2}
          loggedInProps={{
            resource,
          }}
          Loading={ModuleLayoutMockTabs}
        />
      </Suspense>
    </LayoutContainer>
  );
}

const LayoutContainer = styled.div`
  height: 100%;
  width: 100%;
  padding: 15px;
`;
